import { Cdr } from '@reliance/types/models/Cdr';
import { IAuthToken } from '../models/auth';
import { IApiService, IPaginatedResponse } from '../services/api_service';
import config from '../services/config';

export const cdr = (siteApi: IApiService, getToken: () => IAuthToken) => ({
  get: (id) => {
    return siteApi.get(`/cdr/${id}`);
  },
  index: (params = {}): Promise<IPaginatedResponse<Cdr>> => {
    return siteApi.get('/cdr', { params });
  },
  recordingUrl: (recordingUrl) => {
    if (recordingUrl == null) {
      return null;
    }

    if (recordingUrl.indexOf('http') == -1) {
      recordingUrl = config.api.url + recordingUrl;
    }

    var separator = recordingUrl.indexOf('?') > -1 ? '&' : '?';
    return recordingUrl + separator + 'token=' + getToken().accessToken;
  },
  excelIndexUrl: (params) => {
    return siteApi.buildUrl('/cdr.xls', {
      ...params,
      token: getToken().accessToken
    });
  },
  pdfUrl: (params = {}): string => {
    return siteApi.buildUrl('/cdr.pdf', {
      ...params,
      token: getToken().accessToken
    });
  }
});
